import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const GaTracker = () => {
  const { pathname, search } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) { first.current = false; return; }
    if (pathname.startsWith('/admin')) return;
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: pathname + search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname, search]);

  return null;
};
